import { Component, OnInit } from '@angular/core';
import { CollectionsService } from '../../../../../services/collections.service';
import { CollectionsV2Service } from '../../../../../services/collectionsV2.service';
import { RentalsService } from '../../../../../services/rentals.service';
import { PartnerService } from '../../../../../services/partner.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { ServiceRequestService } from '../../../../../services/servicerequest.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rentals-delivery-summary',
  templateUrl: './rentals-delivery-summary.component.html',
  styleUrls: ['./rentals-delivery-summary.component.scss']
})
export class RentalsDeliverySummaryComponent {
  public collectionServicesList: any = [];
  public loading = false;

  public loadingPartners = false;
  public linkedPartners: any = [];
  public selectedPartners: any = [];
  public selectedPartnerIds: any = [];

  public showRentalReservation : boolean = false;
  public selectedReservation : any = {};
  public categories: any = [];
  public brands: any = [];
  public sizes: any = [];
  public rentalStoreRules: any = {};

  public date = moment();
  public tab = 'Deliveries';
  public partnerID: number = 0;
  public duration = 'Week';
  startWeek = moment().startOf('week');
  endWeek = moment().endOf('week');
  configured: boolean = false;
  checkingConfiguration: boolean = false;
  public countryData: any = {};

  public deliveryColumns: any = [
    {
      header: this.translate.instant('general.reservation_no'),
      field: 'reservationNumber',
      type: 'reservationNumber',
    },
    {
      header: this.translate.instant('bikeshop.collections.address'),
      field: 'fullAddress',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.name'),
      field: 'customer',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.contact_details'),
      field: 'phoneNumber',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.date'),
      field: 'scheduleDate',
      type: 'date',
    },
    {
      header: this.translate.instant('bikeshop.collections.time'),
      field: 'timeSlot',
      type: 'time',
    },
    {
      header: this.translate.instant('bikeshop.collections.delivered'),
      field: 'Collected',
      type: 'action',
    },
  ];

  public collectionColumns: any = [
    {
      header: this.translate.instant('general.reservation_no'),
      field: 'reservationNumber',
      type: 'reservationNumber',
    },
    {
      header: this.translate.instant('bikeshop.collections.address'),
      field: 'fullAddress',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.name'),
      field: 'customer',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.contact_details'),
      field: 'phoneNumber',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.date'),
      field: 'scheduleDate',
      type: 'date',
    },
    {
      header: this.translate.instant('bikeshop.collections.time'),
      field: 'timeSlot',
      type: 'time',
    },
    {
      header: this.translate.instant('bikeshop.collections.collected'),
      field: 'Collected',
      type: 'action',
    },
  ];


  constructor(
    public router: Router,
    public collectionService: CollectionsService,
    public collectionsV2Service: CollectionsV2Service,
    private translate: TranslateService,
    public partnerService: PartnerService,
    public helpersService: HelpersService,
    private serviceRequest: ServiceRequestService,
    public modalService: NgbModal,
    public rentalsService : RentalsService
  ) {
    this.partnerID = this.helpersService.getPartnerId();
  }

  ngOnInit() {
    this.selectedPartnerIds = [this.partnerID];
    this.countryData = this.helpersService.getCountryData();
    this.getRentalConfig();
    this.getData();
    this.getLinkedEnabledPartners();
  }

  getRentalConfig() {
    this.checkingConfiguration = true;
    this.rentalsService
      .getRentalConfiguration(this.helpersService.getPartnerId())
      .subscribe((config) => {
        this.rentalStoreRules = config;
        this.checkingConfiguration = false;
        this.configured = this.rentalStoreRules && this.rentalStoreRules.enableDeliveries;
      },err=>{
        this.checkingConfiguration = false;
      });
  }

  getLinkedEnabledPartners() {
    this.loadingPartners = true;
    this.collectionsV2Service
      .getEnabledLinkedPartners(this.partnerID)
      .subscribe(
        (res) => {
          this.linkedPartners = res;
          this.loadingPartners = false;

          this.selectedPartners.push(
            this.linkedPartners.find((y) => y.partnerID == this.partnerID),
          );

          if (this.linkedPartners.length > 1) {
            this.deliveryColumns.unshift({
              header: this.translate.instant(
                'bikeshop.shop_profile.collections.store_name',
              ),
              field: 'store',
              type: 'string',
            });
            this.collectionColumns.unshift({
              header: this.translate.instant(
                'bikeshop.shop_profile.collections.store_name',
              ),
              field: 'store',
              type: 'string',
            });
          }
        },
        (err) => {
          this.loadingPartners = false;
        },
      );
  }

  goToConfiguration() {
    this.router.navigateByUrl('/store/rentals/deliveries-and-collections');
  }

  changeTab(e) {
    console.log(e)
    console.log(e.index)
    if (e.index == 0) {
      this.tab = 'Deliveries';
      this.getData();
    } else if(e.index == 1) {
      this.tab = 'Collections';
      this.getData();
    }
  }

  setCollected(reservation) {
    if (this.tab === 'Collections') {
      if(reservation.reservationStatusID >= 30){
        this.collectionService
          .updateRentalCollectionStatus(reservation.reservationID, reservation.completed)
          .subscribe((res) => console.log(res));
      }
    } else {
      this.collectionService
        .updateRentalDeliveryStatus(reservation.reservationID, reservation.completed)
        .subscribe((res) => console.log(res));
    }
  }

  increaseDate() {
    if (this.duration === 'Day') {
      this.date = this.date.add(1, 'days');
      this.getData();
    } else {
      this.startWeek.add(1, 'week').startOf('week');
      this.endWeek.add(1, 'week').endOf('week');
      this.getData();
    }
  }

  decreaseDate() {
    if (this.duration === 'Day') {
      this.date = this.date.subtract(1, 'days');
      this.getData();
    } else {
      this.startWeek.subtract(1, 'week').startOf('week');
      this.endWeek.subtract(1, 'week').endOf('week');
      this.getData();
    }
  }

  getData() {
    this.loading = true;
    if (this.tab === 'Collections') {
      this.collectionService
        .getRentalCollections(
          this.duration === 'Week'
            ? this.startWeek.format('YYYY-MM-DD')
            : this.date.format('YYYY-MM-DD'),
          this.duration === 'Week'
            ? this.endWeek.format('YYYY-MM-DD')
            : this.date.format('YYYY-MM-DD'),
          this.selectedPartnerIds.join(','),
        )
        .subscribe(
          (res) => {
            this.collectionServicesList = res;
            this.collectionServicesList = this.collectionServicesList.map(
              (x) => {
                return { ...x, collected: x.statusID === 10 ? 1 : 0 };
              },
            );
            console.log();
            this.loading = false;
          },
          (err) => {
            this.collectionServicesList = [];
            this.loading = false;
          },
        );
    } else {
      this.collectionService
        .getRentalDeliveries(
          this.duration === 'Week'
            ? this.startWeek.format('YYYY-MM-DD')
            : this.date.format('YYYY-MM-DD'),
          this.duration === 'Week'
            ? this.endWeek.format('YYYY-MM-DD')
            : this.date.format('YYYY-MM-DD'),
          this.selectedPartnerIds.join(','),
        )
        .subscribe(
          (res) => {
            this.collectionServicesList = res;
            this.collectionServicesList = this.collectionServicesList.map(
              (x) => {
                return { ...x, collected: x.statusID === 20 ? 1 : 0 };
              },
            );
            this.loading = false;
          },
          (err) => {
            this.collectionServicesList = [];
            this.loading = false;
          },
        );
    }
  }

  print() {
    // this.router.navigateByUrl("print-deliveries", {
    //   state: {
    //     collectionServicesList: this.collectionServicesList,
    //     date: this.date.format("ll") + "",
    //     type: this.tab,
    //   },
    // });

    console.log(this.selectedPartnerIds);

    var win = window.open(
      `/print-deliveries?Type=${this.tab}&StartDate=${this.duration === 'Week' ? this.startWeek.format('YYYY-MM-DD') : this.date.format('YYYY-MM-DD')}&EndDate=${this.duration === 'Week' ? this.endWeek.format('YYYY-MM-DD') : this.date.format('YYYY-MM-DD')}&Partners=${this.selectedPartnerIds.join(',')}`,
      '_blank',
    );
    win.focus();
  }

  changeDuration(duration) {
    this.duration = duration;
    this.getData();
  }

  openReservation(reservationID) {
    console.log(reservationID)
    this.selectedReservation = {id : reservationID};
    this.showRentalReservation = true;
  }

  updateFilter(partner) {
    this.selectedPartnerIds = partner.map((x) => {
      return x.partnerID;
    });
    this.selectedPartners = partner;
    console.log(this.selectedPartnerIds);
    console.log(this.selectedPartners);
    this.getData();
  }
}
